var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"properties-centent kk-checkbox"},[_c('div',{staticClass:"properties-body"},[_c('div',{staticStyle:{"font-size":"18px","font-weight":"bold","text-align":"center","margin-bottom":"10px","color":"#2b5e7d"}},[_vm._v("\n      "+_vm._s(_vm.currentForm.name)+"\n    ")]),_c('form-view',{attrs:{"base-data":_vm.currentForm}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }